export default {
    '$route.name': function() {
        if (this.$route.name === 'Criar Trip') {
            this.resetTrip()
        }
    },
    'trip.boardingPlaces.date': {
        handler: function() {
            this.checkForLongBoardingIntervals()
            this.checkForLongReturnInterval()
        },
        deep: true
    },
    'trip.stopTime': function() {
        this.checkForLongReturnInterval()
    }
}
